import { getAssetsUrlWithHttp, resolveAssetImage } from "@/utils/common"
import styled from "@emotion/styled"
import { memo } from "react"
import { useEnterGame } from "../hooks/useEnterGame"
import { GameCardFavButton } from "./GameCardFavButton"

const Container = styled.div`
    position: relative;
    overflow: hidden;
    height: 152rem;
    width: 100%;
`

const Post = styled.img`
    width: 100%;
    height: 152rem;
    border-radius: 10rem;
    overflow: hidden;
    position: relative;
    object-fit: cover;
    background-color: rgba(0, 0, 0, 0.1);
`

interface CardItemProps extends GameApiTypes.Fetcher.Result.GameList {}

export const GameCardItem = memo((props: CardItemProps) => {
    const { handleEnterGame } = useEnterGame()
    const { id = "", img = "", code = "" } = props

    return (
        <Container
            onClick={() => {
                handleEnterGame(code)
            }}
        >
            <Post
                src={getAssetsUrlWithHttp(img)}
                loading="lazy"
                onError={(e) => {
                    // e.currentTarget.src = resolveAssetImage("pages/HomePage/img_not_found.webp")
                }}
                alt=""
            />
            <GameCardFavButton id={id} />
        </Container>
    )
})
